import { remoteAppAsyncConfig, remoteConfig } from '../config/async-remoteApps';

import { init } from '@module-federation/runtime';

const remoteApps: remoteConfig[] = []
Object.keys(remoteAppAsyncConfig).forEach(key => {
    remoteApps.push({
      name:key,
      alias: key,
      entry: remoteAppAsyncConfig[key]
    })
  })

init({
  name: 'spm-ts-remote-apps',
  remotes:remoteApps,
});